'use strict';

var $trimStart = require('../internals/string-trim').start;

var forcedStringTrimMethod = require('../internals/string-trim-forced'); // `String.prototype.{ trimStart, trimLeft }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// https://tc39.es/ecma262/#String.prototype.trimleft


module.exports = forcedStringTrimMethod('trimStart') ? function trimStart() {
  return $trimStart(this); // eslint-disable-next-line es-x/no-string-prototype-trimstart-trimend -- safe
} : ''.trimStart;